/*
kavyareddy 03/1/2023 2699234404 Added Scheduler execution history search table
kavyareddy 03/1/2023 2699234404 Added startDate and endDate
kavyareddy 03/1/2023 2699234404 Fixed payload issue and label issue
Dilip 02/09/2023 2699234404 added created for, created by dropdown
Dilip 02/10/2023 2699234404 changed column positions
Akhila 02/15/2023 2699234404 EST format implemented in start date and in end Date
suresh peddavoora 02/21/2023 2699234404 New UI changes
Ravi 02/24/2023 2699234404 implemented previewFile in download Configuration
Sohel 03/01/2023 2699234404 Added loader and download toast a message for preview File
Akhila 05/31/2023 2699234404 pointer bug fixed
Sohel 06/01/2023 2699234404 Added module Name in payload
Akhila 06/08/2023 2699234404 created date change to date created field and column
Akhila 06/16/2023 2699234404 removed date created and created for from col and field
Ravi 06/30/2023 2699234404 fixed search button button functionality
*/
import React, {createRef, useState, useEffect} from 'react';
import {defaultRows, tablePageRows} from '../../../../constants/ReusableTablePagination';
import {useUpdateEffect} from 'react-use';
import {Grid, TablePagination, Tooltip} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../util/Rest';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import {
  postPrintSchedulerExecution,
  resetSchedulerExecutions,
  resetConfigUrl,
  resetDockey,
} from '../../../../redux/reducers/NightJobs/AddNightJob';
import moment from 'moment';
import PageLoader from '../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import axios from 'axios';
import {resetDownloadMsg} from '../../../../redux/reducers/PreviewFileData';

const SchedulerSearchTable = ({searchData, submit, setSubmit}) => {
  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const dispatch = useDispatch();
  const [status, setStatus] = useState(false);
  const {errorMsg, successMsg, isLoading, configurationUrl, dockey} = useSelector(
    ({addNightJob}) => addNightJob,
  );
  const [configOpen, setConfigOpen] = useState(false);
  const [isLoadingPrint, setIsLoadingPrint] = useState(false);
  const [configData, setConfigData] = useState(null);
  useUpdateEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [searchData, successMsg]);

  useUpdateEffect(() => {
    if (status) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetSchedulerExecutions());
      }, 1500);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingPrint(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingPrint(false);
      }
      readData();
    }
  }, [configurationUrl]);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };
  const columns = [
    {
      title: 'Job Name',
      field: 'jobCode',
      render: (rowData) => (
        <span
          // role="button"
          style={{
            maxWidth: 165,
            textAlign: 'justify',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
          }}
        >
          {rowData?.jobCode}
        </span>
      ),
    },
    {
      title: 'Job Description',
      field: 'jobDescription',
      render: (rowData) => (
        <span
          // role="button"
          style={{
            maxWidth: 165,
            textAlign: 'justify',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
          }}
        >
          {rowData?.jobDescription}
        </span>
      ),
    },
    {
      title: 'Execution Status',
      field: 'status',
      render: (rowData) => (
        <span style={{color: rowData.status === 'COMPLETED' ? '#00af00' : '#FA113D'}}>
          {rowData?.status ? rowData?.status : rowData?.status ? rowData?.status : ''}
        </span>
      ),
    },
    // {
    //   title: "Created For",
    //   field: "createdFor",
    // },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    // {
    //   title: "Date Created",
    //   field: "createdDate",
    //   render: (rowData) => {
    //     return rowData?.createdDate ? moment(rowData?.createdDate).format("MM/DD/YYYY") : "";
    //   },
    // },
    {
      title: 'Start Date',
      field: 'startTime',
      render: (rowData) => {
        return rowData?.startTime ? rowData?.startTime : '';
      },
    },
    {
      title: 'End Date',
      field: 'endTime',
      render: (rowData) => {
        return rowData?.endTime ? rowData?.endTime : '';
      },
    },
    // {
    //   title: "Status",
    //   field: "isDraft",
    //   render: (rowData) =>
    //     rowData?.isDraft === "Y" ? (
    //       <div class="completed-status status">
    //         <span style={{ color: "#ff8b00", fontWeight: "bold" }}>Draft</span>
    //       </div>
    //     ) : (
    //       <div class="completed-status status" style={{ fontWeight: "bold", color: "#00af00" }}>
    //         <span>Completed</span>
    //       </div>
    //     ),
    // },
    {
      title: 'Error Message',
      field: 'errorMessage',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.errorMessage?.split(',').join(', ')} interactive>
            <p className="popup-text">{rowData?.errorMessage?.split(',').join(', ')}</p>
          </Tooltip>
        );
      },
      // render: (rowData) => <span style={{ whiteSpace: "pre-wrap" }}>{rowData.errorMessage}</span>,
    },
  ];

  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Scheduler'}
      />
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-actions-icon new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `nightJobs/search/all/executions`;
                const bodyObj = {
                  jobCode: searchData?.jobCode ? searchData.jobCode : '',
                  jobDescription: searchData?.description ? searchData.description : '',
                  executionStatus: searchData?.jobStatus?.value ? searchData?.jobStatus?.value : '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  createdFor: searchData?.createdFor?.userLoginName ?
                    searchData?.createdFor?.userLoginName :
                    '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  startDateTime: searchData?.startTime ?
                    moment(searchData?.startTime).format('MM/DD/YYYY') :
                    '',
                  endDateTime: searchData?.endTime ?
                    moment(searchData?.endTime).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setSubmit(false);
                        setArrayLast(data.length === 1);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            actions={[
              (rowData) => {
                if (rowData?.jobExecutionId) {
                  return {
                    icon: () => <GetAppOutlinedIcon />,
                    tooltip: 'Download',
                    onClick: (event, rowData) => {
                      dispatch(postPrintSchedulerExecution(rowData?.jobExecutionId));
                    },
                  };
                }
              },
            ]}
            options={{
              search: false,
              pageSize: rows,
              toolbar: false,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
        {(isLoading || isLoadingPrint) && <PageLoader />}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </Grid>
    </>
  );
};

export default SchedulerSearchTable;
